import React, {useState} from 'react';
//import { useHistory } from 'react-router-dom'
//import AuthService from "../Services/AuthService";
import {toast} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {css} from "glamor";
import Typography from '@material-ui/core/Typography';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import AuthService from "../Services/AuthService";


const PaseDeListaJVsForm = (props) => {

    //let history = useHistory();

    const [IDU, setIDU] = useState("");
    const [selectedOption, setSelectedOption] = useState('Presencial'); // Manage the radio button selection
    const [definedIDU, setdefinedIDU] = useState(false);
    const [userInfo, setuserInfo] = useState('');
    const [TipoJunta, setTipoJunta] = useState('Presencial');
    const [pdlcomplete, setpdlcomplete] = useState(false);
    const [pdlonprog, setpdlonprog] = useState(false);
    const [isLogged, setisLogged] = useState(AuthService.getCurrentUser());
    const [runOnce, setrunOnce] = useState(false);



    const alerts = (msg, error) => {
        toast(msg, {
            className: css({
                background: error?"#E7332A": "#00AC46",
                color: "white"
            }),
            progressClassName: css({
                background: error? "#00AC46": "white"
            })
        })
    };

    const handleRadioChange = (e) => {
        setTipoJunta(e.target.value);
        setSelectedOption(e.target.value); // Update the selected option state
    };

    const releaseIDU = (e) =>
    {
        AuthService.logout();
        setisLogged(false);
        setrunOnce(false);
        function prettyJSONv(obj) {
            let stringed = JSON.stringify(obj, null, 2);
            return stringed
        }
        let responseToJSON = prettyJSONv(userInfo);
        console.log('userInfo is preRelease:'+responseToJSON);
        setIDU('');
        setdefinedIDU(false);
        setuserInfo('');
    }

//BNDDEV: Remove this
/*
    const JSONdec = (e) =>
    {
        handleValidateIDU();
            function prettyJSONv(obj) {
                let stringed = JSON.stringify(obj, null, 2);
                return stringed
            }
            let responseToJSON = prettyJSONv(isLogged);
            console.log('decJSON is:'+responseToJSON);
            console.log('--->getIDU:'+isLogged.idu);
            let iduPASS = isLogged.idu;
            //setIDU(iduPASS);
    }
            */

    const handleIDUChange = (e) =>
    {
        setIDU(e.target.value);
    };

    const handleValidateIDU = (e) =>
    {
        if(!runOnce){
            setrunOnce(true);
        
        console.log('----->BNDDEV: IDU To check:'+IDU);
        let LoggedStat = "false";
        let WichIDU = IDU;
        if(isLogged){
            LoggedStat = "true";
            WichIDU = isLogged.idu;
        } else {
            LoggedStat = "false";
        }
        AuthService.getPDLidu(WichIDU, LoggedStat)
                    .then(resp => {
                        function prettyJSONv(obj) {
                            let stringed = JSON.stringify(obj, null, 2);
                            return stringed
                        }
                        let responseToJSON = prettyJSONv(resp.data);
                        console.log('---->BNDDEV: Data from IDU GOT:'+responseToJSON);

                        if(!resp.data.success){
                            setdefinedIDU(false);
                            setuserInfo('');
                            alerts("Usuario no existente", true);
                        } else {
                            setdefinedIDU(true);
                            setuserInfo(resp.data);
                            console.log('userInfo is:'+userInfo);
                            alerts("Valida tus Datos", false);
                        }
                    })
                    .catch(error=>{console.log(error)});
        }
    }

    const handlePasarLista = (e) =>
    {
        setpdlonprog(true);
        let WichIDU = IDU;
        if(isLogged){
            WichIDU = isLogged.idu;
        }
        //let TipoJunta = 'Virtual';
        let Fecha = getCurrentDate();
        AuthService.doPDL(WichIDU, TipoJunta, Fecha)
        .then(resp => {
            function prettyJSONv(obj) {
                let stringed = JSON.stringify(obj, null, 2);
                return stringed
            }
            let responseToJSON = prettyJSONv(resp.data);
            console.log('---->BNDDEV: Data from hacer pase de lista:'+responseToJSON);

            if(!resp.data.success){
                alerts("Error al realizar el pase de lista", true);
            } else {
                setpdlcomplete(true);
                alerts("Pase de lista completado", false);
            }
        })
        .catch(error=>{console.log(error)});
        console.log('onProg');
    }

    const getCurrentDate = () => {
        const today = new Date();
        const day = String(today.getDate()).padStart(2, '0'); // Ensure two digits
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const year = today.getFullYear();
        return `${day}/${month}/${year}`;
    };


    return (
        <Container component="main" className="loginMain" maxWidth="xs">
            <CssBaseline/>
            <div className="pdlPaper">

                <img src="/assets/img/pasebk.png" alt="Header"
                                                             style={{width: "120%", margin: "5px", marginRight: '8px', marginBottom: '-80px'}}/>
                <br/>
                <br/>
                <Typography component="h1" variant="h5">
                    Asistencia a mi
                </Typography>
                <Typography component="h1" variant="h4">
                    Junta de Ventas
                </Typography>
                <Typography component="h1" variant="h3">
                 {getCurrentDate()}
                </Typography>
                
                {isLogged && !pdlcomplete && (
                    <React.Fragment>
                        {handleValidateIDU()}
                        <div className="row note-login pdlbodytxtstitles">
                        <p>
                            ¡Hola, <span className="pdlbodytxtslogged">{userInfo.Nombre}</span>!
                        </p>
                        </div>

                        <div className="row note-login pdlbodytxtstitles">
                        <p>
                            IDU: <span className="pdlbodytxtslogged">{userInfo.idu}</span>
                        </p>
                        </div>

                        <div className="row note-login pdlbodytxtstitles">
                        <p>
                            Gerente <span className="pdlbodytxts">{userInfo.Gerente}</span>
                        </p>
                        </div>

                        <div className="row note-login nosoyyotxt">
                        <p>
                        <button onClick={releaseIDU} className="relogintxtlnkbtn">
                            No soy yo
                        </button>
                        </p>
                        </div>
                    </React.Fragment>
                )}

                {!definedIDU && !isLogged && (
                    <React.Fragment>
                        <div className="row txtloginspace">
                                <p>
                                    <a href="/LoginPDL" className="logintxtlnk">Inicia sesión</a> o escribe tu IDU
                                </p>
                        </div>


                            <div className="row myFlex">
                                <div className="input-field col s12">
                                    <input id="iduCheck" type="text" name="iduCheck" className="validate"
                                           onChange={handleIDUChange}/>
                                    <label htmlFor="iduCheck">IDU</label>
                                </div>
                                <button onClick={handleValidateIDU} style={{float: "right"}}
                                        className="pdlbutton">
                                    Validar
                                    </button>
                            </div>
                    </React.Fragment>
                )}
            </div>

        {definedIDU && !pdlcomplete && !isLogged &&(
            <React.Fragment>
                <div className="row note-login pdlbodytxtstitles">
                    <p>
                        Nombre
                    </p>
                </div>
                <div className="row note-login pdlbodytxts">
                    <p>
                    {userInfo.Nombre}
                    </p>
                </div>

                <div className="row note-login pdlbodytxtstitles">
                    <p>
                        Oficina
                    </p>
                </div>

                <div className="row note-login pdlbodytxts">
                    <p>
                    {userInfo.Oficina}
                    </p>
                </div>

                <div className="row note-login nosoyyotxt">
                    <p>
                        <button onClick={releaseIDU} className="relogintxtlnkbtn">
                            No soy yo
                        </button>
                    </p>
                </div>
                </React.Fragment>
        )}
        
        {definedIDU && !pdlcomplete && !pdlonprog &&(
            <React.Fragment>

                <div className="row note-login pdlbodytxts">
                    <p>
                        ¿Tu Junta fue presencial o virtual?
                    </p>
                </div>

                <div className="row">
                    <div className="col s12 radio-container">
                        <label>
                            <input
                                type="radio"
                                value="Presencial"
                                checked={selectedOption === 'Presencial'}
                                onChange={handleRadioChange}
                            />
                            <span>Presencial</span>
                        </label>
                        <br />
                        <label>
                            <input
                                type="radio"
                                value="Virtual"
                                checked={selectedOption === 'Virtual'}
                                onChange={handleRadioChange}
                                />
                            <span>Virtual</span>
                        </label>
                        </div>
                </div>

                <div className="row content-btn-login pdlbuttoncontainer">
                    <button onClick={handlePasarLista} style={{float: "right"}}
                        className="pdlbuttontwo">
                            Enviar
                    </button>
                </div>

            </React.Fragment>
        )}

        {definedIDU && !pdlcomplete && pdlonprog &&(
            <React.Fragment>

                <div className="row note-login pdlbodytxts">
                    <p>
                        Enviando...
                    </p>
                </div>

                <div className="row note-login pdlbodytxts">
                    <p>
                        Un momento por favor.
                    </p>
                </div>
            </React.Fragment>
        )}

        {pdlcomplete && (
            <React.Fragment>

        <div className="row note-login pdlbodytxtstitles pdlthankyou">
                    <p>
                    ¡Gracias, se guardó tu pase de lista a la Junta de Ventas de hoy!
                    </p>
        </div>

        </React.Fragment>
        )}

        

        <div class="pdlfooter">
        <img src="/assets/img/thermomix_header_2023.png" alt="Header"
            style={{maxWidth: "170px", width: "100%", margin: "auto", marginLeft: '27%', marginBottom: '0px', marginTop: '25px'}}/>
        </div>

        </Container>
    );
};
export default PaseDeListaJVsForm;